import React, { Component } from "react";
import Helmet from "react-helmet";
import config from "../siteConfig";

class SEO extends Component {
  render() {
    const { pageSEO, article } = this.props;

    let title = pageSEO.title;
    let description = pageSEO.description;
    let url = config.siteUrl + pageSEO.path;
    let image = config.facebookShareImageUrl;



    // const schemaOrgJSONLD = [
    //   {
    //     "@context": "http://schema.org",
    //     "@type": "WebSite",
    //     url: config.siteUrl,
    //     name: title,
    //     alternateName: "Protectia Muncii"
    //   }
    // ];
    //
    //
    // if (postSEO) {
    //   schemaOrgJSONLD.push([
    //     {
    //       "@context": "http://schema.org",
    //       "@type": "BreadcrumbList",
    //       itemListElement: [
    //         {
    //           "@type": "ListItem",
    //           position: 1,
    //           item: {
    //             "@id": postURL,
    //             name: title,
    //             image
    //           }
    //         }
    //       ]
    //     },
    //     {
    //       "@context": "http://schema.org",
    //       "@type": "BlogPosting",
    //       url: blogURL,
    //       name: title,
    //       alternateName: config.siteTitleAlt ? config.siteTitleAlt : "",
    //       headline: title,
    //       image: {
    //         "@type": "ImageObject",
    //         url: image
    //       },
    //       description
    //     }
    //   ]);
    // }
    return (
      <Helmet>
        {/* General tags */}
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta name="image" content={image} />

        {/* Schema.org tags */}
        {/*<script type="application/ld+json">*/}
          {/*{JSON.stringify(schemaOrgJSONLD)}*/}
        {/*</script>*/}

        {/* OpenGraph tags */}
        <meta property="og:url" content={url} />
        {article ? <meta property="og:type" content="article" /> : null}
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:image" content={image} />
        <meta
          property="fb:app_id"
          content={config.siteFBAppID ? config.siteFBAppID : ""}
        />
      </Helmet>
    );
  }
}

export default SEO;


// WEBPACK FOOTER //
// ./src/components/SEO.js